import React from 'react';
import { Form as SemanticForm, FormComponent } from 'semantic-ui-react';

import UploadField, { Props as UploadProps } from './UploadField';
import DatePickerField, { Props as DatePickerProps } from './DatePickerField';
import EditorField, { Props as EditorProps } from './EditorField';
import DropzoneField, { Props as DropzoneProps } from './DropzoneField';
import DropdownField, { Props as CustomDropdownProps } from './DropdownField';
import RadioGroupField, {
  Props as RadioGroupFieldProps,
} from './RadioGroupField';
import FeedbackField from './FeedbackField';
import PhoneField, { Props as PhoneFieldProps } from './PhoneField';
import ImageUploadField, { Props as ImageUploadProps } from './ImageUpload';

export interface IForm extends FormComponent {
  Upload: React.FC<UploadProps>;
  DatePicker: React.FC<DatePickerProps>;
  Editor: React.FC<EditorProps>;
  Dropzone: React.FC<DropzoneProps>;
  CustomDropdown: React.FC<CustomDropdownProps>;
  RadioGroup: React.FC<RadioGroupFieldProps>;
  FeedbackField: React.FC<RadioGroupFieldProps>;
  PhoneField: React.FC<PhoneFieldProps>;
  ImageUploadField: React.FC<ImageUploadProps>;
}

const Form = SemanticForm as IForm;

Form.Upload = UploadField;
Form.DatePicker = DatePickerField;
Form.Editor = EditorField;
Form.Dropzone = DropzoneField;
Form.CustomDropdown = DropdownField;
Form.RadioGroup = RadioGroupField;
Form.FeedbackField = FeedbackField;
Form.PhoneField = PhoneField;
Form.ImageUploadField = ImageUploadField;

export default Form;
